import React, { Component } from 'react';
import {
    View,

    StyleSheet,
    Image,
    Platform,
    TouchableOpacity,
    TouchableWithoutFeedback,
    Linking,
    Dimensions
} from 'react-native';
import { Button, Card, Surface } from "react-native-paper";
import { imageBaseUrl } from './../../store/constants/apiConstants';
import moment from 'moment';
import { Text, Styles } from "./../../components/UI-Components";
import AdsScreen from './../Ads';
import { HoverComponent } from './'
import { withRouter } from 'react-router-dom';
import { ArticlesComponent } from "./../../components";
import { CURRENT_AFFAIRS, CURRENT_AFFAIRS_SCREEN_NAME,  TOPIC_LIBRARY_SCREEN, ARTICLES } from './../../store/constants/bookmarkConstants';
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import Share from "@material-ui/icons/Share";


const { width, height } = Dimensions.get("window");
class CurrentAffairs extends Component {

    constructor(props) {
        super(props);
        //any thing can write here
    }

    handleClick = (url) => {
        Linking.canOpenURL(url).then(supported => {
            if (supported) {
                Linking.openURL(url);
            }
        });
    };

    addBookmark = (item) => {
        const data = {
            content_id: item.id,
            content_name: 'titleId',
            content_url: "null",
            screen_name: CURRENT_AFFAIRS_SCREEN_NAME,
            type: CURRENT_AFFAIRS,
            image_url: item.url,
            description: null,
            title: item.title
        }
        this.props.addBookMark(data)

    }

    share = () => null;

    render() {
        const { currentAffairs, fromList, currentAffairBookmarks, addBookMarkLoading, deleteBookMark, articleBookMark } = this.props;
        const { ids = {}, bookmarks = [] } = currentAffairBookmarks || {};
        // console.log(bookmarks, "sdfsd", ids)
        let _bookMarkId;
        let _isBookMarked;
        if(fromList){
               _isBookMarked = ids[currentAffairs.id]
                _bookMarkId = bookmarks.find(c => c.content_id === currentAffairs.id);
             
        }

        return (
            <>
                {
                    !fromList ? (
                        <View style={{ marginHorizontal: 10, flex: 1 }}>
                            <div className='current_affairs_compo'>

                                {
                                    currentAffairs && currentAffairs.length && currentAffairs.map((item, index) => {

                                        const isBookmarked = ids[item.id];
                                        const bookmark = bookmarks.find(c => c.content_id === item.id);
                                        console.log(isBookmarked, "bookmarked")
                                        // if(index >= 2) return;
                                        return (
                                            <ArticlesComponent
                                                navigation={this.props.history}
                                                item={item}
                                                index={index}
                                                isBookmarked={isBookmarked}
                                                bookmarkId={bookmark?.id}
                                                deleteBookMark={this.props.deleteBookMark}
                                                addBookmark={() => this.addBookmark(item)}
                                                addBookMarkLoading={addBookMarkLoading}
                                                share={() => this.share(item.id, item.url, item.title, item.content)}

                                            />
                                        )
                                    })

                                }
                            </div>
                            <View style={{ justifyContent: 'center', alignItems: 'center', marginVertical: 10 }}>
                                <View >
                                    {/* <TouchableWithoutFeedback
                            onPress= { () => {
                                alert()
                                return;
                                // this.handleClick('https://iaseasy.in/')
                            }}
                            style={{flexDirection:'row'}}>
                                <Text style={{color:'#0D47A1',fontSize:15}}>Moredd</Text>
                                    <View style={{marginLeft:5}}>
                                        <Icon 
                                        name={"ios-arrow-round-down"}
                                        size={20}
                                        color={"#0D47A1"}
                                        />
                                    </View>
                            </TouchableWithoutFeedback> */}
                                </View>
                            </View>
                            {
                                this.props.adsTrue &&
                                <View style={{ marginTop: 30 }}>
                                    <AdsScreen screenName={'CurrentAffairs'} />
                                </View>
                            }
                        </View>
                    ) : (
                            <View style={{ flex: 1,  flexDirection: 'row',
                            flexWrap: 'noWrap'}}>
                               
                                        <ArticlesComponent
                                            navigation={this.props.history}
                                            item={currentAffairs}
                                            index={1}
                                            isBookmarked={_isBookMarked}
                                            bookmarkId={_bookMarkId?.id}
                                            deleteBookMark={this.props.deleteBookMark}
                                            addBookmark={() => this.addBookmark(currentAffairs)}
                                            addBookMarkLoading={addBookMarkLoading}
                                            fromList={true}
                                        // share={() => this.share(item.id, item.url, item.title, item.content)}

                                        />

{/*                              
                                 <View style={{ justifyContent: 'center', alignItems: 'center', marginVertical: 10 }}>
                                    <View >
                                        <TouchableWithoutFeedback
                            onPress= { () => {
                                alert()
                                return;
                                // this.handleClick('https://iaseasy.in/')
                            }}
                            style={{flexDirection:'row'}}>
                                <Text style={{color:'#0D47A1',fontSize:15}}>Moredd</Text>
                                    <View style={{marginLeft:5}}>
                                        <Icon 
                                        name={"ios-arrow-round-down"}
                                        size={20}
                                        color={"#0D47A1"}
                                        />
                                    </View>
                            </TouchableWithoutFeedback>
                                    </View>
                                </View> */}
                                {
                                    this.props.adsTrue &&
                                    <View style={{ marginTop: 30 }}>
                                        <AdsScreen screenName={'CurrentAffairs'} />
                                    </View>
                                }
                            </View>
                        )
                }

            </>
        )
    }
}

const styles = StyleSheet.create({
    heading: {
        fontSize: 20,
        color: '#222',
        paddingLeft: 10,
        marginVertical: 20,

    },
    currentAffairsDescription: {
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: 10
    },
    ImageStyle: {
        justifyContent: width <= 780 ? 'flex-start' : 'center',
        alignItems: width <= 780 ? 'flex-start' : 'center',
        marginTop: 10,
        width: 100,
        height: 80,
        resizeMode: 'contain',
        // backgroundColor:Color.imageBgColor,
        borderRadius: 2,
        marginBottom: 10
    },
    currentAffairscontent: {
        // height:70,
        paddingHorizontal: 10,
        paddingTop: 2,
        textAlign: 'justify',
        // borderWidth: 1,
        marginTop: -5,
        fontWeight: 'bold'
    },
    card_shadow: {
        marginVertical: 4,
        // backgroundColor:'#fcfcfc',
        // shadowColor: '#000',
        // shadowOffset: { width: 0, height: 1 },
        // shadowOpacity: 0.4,
        // shadowRadius: 1.5,
        width: width <= 780 ? '100%' : (window.innerWidth / 3 - 20),
        marginHorizontal: width <= 780 ? 0 : 10,
        flex: 1,
        display: 'flex',
        flexDirection: width <= 780 ? 'row' : 'column',
        elevation: 8,
        borderRadius: 10,
        cursor: 'pointer'

        // justifyContent: width <= 780 ?  'flex-start' : 'center',
        // alignItems:width <= 780 ?  'flex-start' : 'center',

    },
    actions: {
        position: 'absolute',
        top: 4,
        right: 8,
        paddingVertical: 2,
        // borderWidth: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
})

export default withRouter(CurrentAffairs);
